import { z } from 'zod';

import { requiredString } from '../../utils/validation';

export const CERT_FIELDS = ['ca_keys', 'ca_certs', 'tls_auth'];

/**
 * Validation for the cert upload form. `pfSense_format` / `pfSense_tls`
 * come from the current lab (not user input) and decide whether the TLS
 * auth key is mandatory.
 */
export const labCertsSchema = z
    .object({
        ca_keys: requiredString('CA Key'),
        ca_certs: requiredString('CA Cert'),
        tls_auth: z.any().optional(),
        pfSense_format: z.any().optional(),
        pfSense_tls: z.any().optional(),
    })
    .superRefine((data, ctx) => {
        if (data.pfSense_format === 1 && data.pfSense_tls === 1 && !data.tls_auth) {
            ctx.addIssue({
                code: 'custom',
                path: ['tls_auth'],
                message: 'TLS auth is required when pfSense TLS is enabled',
            });
        }
    });
